import { SEO } from '../components/seo/SEO';

export default function NotFoundPage() {
  return (
    <>
      <SEO
        title="ページが見つかりません"
        description="お探しのページは見つかりませんでした"
      />
      
      <div className="min-h-screen flex items-center justify-center py-8 sm:py-12">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-20 h-20 sm:w-24 sm:h-24 flex items-center justify-center mx-auto mb-6 sm:mb-8">
            <i className="ri-error-warning-line text-7xl sm:text-8xl text-cosmic-accent-violet"></i>
          </div>
          <h1 className="text-5xl sm:text-6xl font-bold mb-3 sm:mb-4 text-cosmic-text-primary">404</h1>
          <h2 className="text-xl sm:text-2xl font-semibold mb-4 sm:mb-6 text-cosmic-text-primary">
            ページが見つかりません
          </h2>
          <p className="text-sm sm:text-base text-cosmic-text-secondary mb-6 sm:mb-8 leading-relaxed">
            お探しのページは存在しないか、移動した可能性があります。
          </p>
          <a
            href="/"
            className="cosmic-button-primary inline-block cursor-pointer"
          >
            <i className="ri-home-line mr-2"></i>
            ホームに戻る
          </a>
        </div>
      </div>
    </>
  );
}
